import LawsuitUpdatesCounter from "./LawsuitUpdatesCounter";

export default LawsuitUpdatesCounter;
